import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { approveUser } from "src/actions/usersActions";
import Loading from "src/components/Loading";
import Message from "src/components/Message";
import { setToken } from "src/utils/storage";

const EmailValidate = (props) => {
  const hash = useMemo(() => props.match.params.hash, [props]);
  const { loading } = useSelector((state) => state.users);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { is_authenticated } = useSelector((state) => state.auth);

  const redirect = props.location.search
    ? props.location.search.split("=")[1]
    : "/";

  useEffect(() => {
    if (!is_authenticated) {
      dispatch(approveUser(hash))
        .then((res) => {
          setToken(res.Token);
          window.location.href = "/companies";
        })
        .catch((error) => {
          setError(error.data);
        });
    } else {
      props.history.push(redirect);
    }
  }, [hash, is_authenticated, props.history, redirect]);

  return (
    <div className="p-4">
      {loading && <Loading />}
      {!loading && !error && (
        <Message variant="success" title={t("register.emailValidateSuccess")} />
      )}
      {error && <Message variant="danger" title={error.Status.Message} />}
    </div>
  );
};

export default EmailValidate;
